/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TerminalVehicleFuelSettingsApiModel {
  /**
   * Odometer measuremen units selection type
   */
  odometer_measurement_units?: TerminalVehicleFuelSettingsApiModelOdometerMeasurementUnitsEnum | null;
}
export enum TerminalVehicleFuelSettingsApiModelOdometerMeasurementUnitsEnum {
  Kilometer = 'kilometer',
  Mile = 'mile',
  Hour = 'hour',
  SelectedByCustomer = 'selected-by-customer',
  SetByVolumeUnit = 'set-by-volume-unit'
}
